
import 'normalize.css'
import '@/assets/scss/common.scss'
import Fingerprint2 from 'fingerprintjs2'
import Vue from 'vue'
import Axios from 'axios'
import App from '@/App'
import { i18n } from '@/i18n'
import store from '@/store'
import router from '@/router'
import { checkProduction } from '@/assets/constants/production'
import { getCookie, getLocalStorage } from '@/assets/helpers/UtilHelper'
import './registerServiceWorker'
Vue.use(require('vue-moment'))
Vue.use(require('vue-scrollto'))

const currentProduction = checkProduction()
const tokenInCookie = getCookie(process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY)
const tokenInLocalStorage = getLocalStorage(process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY)
Fingerprint2().get((result, components) => {
  // console.log(result) // a hash, representing your device fingerprint
  // console.log(components) // an array of FP components
  // window.fingerprint = result
  window.localStorage.setItem('fingerprint', result)

  // //////////////////////////
  gtag('config', 'G-HCLBKFJXVZ', {
    'custom_map': { 'dimension1': 'fingerprint' },
    'optimize_id': 'GTM-M9TLS8P'
  })
  // Sends the custom dimension to Google Analytics.
  gtag('event', 'page_view', { 'fingerprint': result })
})

// Axios.defaults.withCredentials = true
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
Axios.interceptors.response.use(
  res => {
    // console.log('axiosInstance interceptors')
    if (res && res.headers) {
      let refreshAuthorization = res.headers['authorization'] || res.headers['Authorization']
      if (refreshAuthorization) {
        // console.log('Update refresh authorization in interceptors')
        if (refreshAuthorization.indexOf('Bearer ') > -1) {
          refreshAuthorization = refreshAuthorization.replace('Bearer ', '')
        }
        if (refreshAuthorization) { // still a token
          window.localStorage.setItem(process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY, refreshAuthorization)
          store.dispatch('AUTH_TOKEN', refreshAuthorization)
        }
      }
    }
    return res
  }, err => Promise.reject(err)
)

if (tokenInLocalStorage) {
  store.dispatch('AUTH_TOKEN', tokenInLocalStorage)
} else if (tokenInCookie) {
  store.dispatch('AUTH_TOKEN', tokenInCookie)
} else {
  // User is not logged in.
}

const detectMobile = () => {
  let userAgent = navigator.userAgent.toLowerCase()
  if (
    userAgent.match(/Android/i) ||
    userAgent.match(/webOS/i) ||
    userAgent.match(/iPhone/i) ||
    userAgent.match(/iPad/i) ||
    userAgent.match(/iPod/i) ||
    userAgent.match(/BlackBerry/i) ||
    userAgent.match(/Windows Phone/i) ||
    // || navigator.userAgent.match(/Googlebot-Mobile/i)
    // || navigator.userAgent.match(/googlebot-mobile/i)
    // || navigator.userAgent.match(/Mobile/i)
    // || navigator.userAgent.match(/mobile/i)
    (userAgent.match(/Googlebot/i) && userAgent.match(/Mobile/i))
  ) {
    return true
  }
  return false
}
const detectSafari = () => {
  return (window.navigator.userAgent.indexOf('Safari') !== -1 && window.navigator.userAgent.indexOf('Chrome') === -1)
}
const detectCNDomian = () => {
  const cAry = window.location.host.split('.')
  return cAry[cAry.length - 1].toLowerCase() === 'cn'
}
const updateClientWidth = () => {
  store.commit('resize')
}

window.addEventListener('resize', updateClientWidth)

// Work around solution: https://github.com/vuejs/vue-router/issues/2356
// Not fixed version yet.
const RouterView = Vue.component('router-view')
const RouterLink = Vue.component('router-link')
Vue.component('RouterView', RouterView)
Vue.component('RouterLink', RouterLink)
// //////////////

Vue.prototype.$isMobile = detectMobile()
Vue.prototype.$isSafari = detectSafari()
Vue.prototype.$isCN = detectCNDomian()
Vue.prototype.$production = currentProduction
Vue.prototype.$http = Axios
const hostname = window.location.hostname
Vue.prototype.$isProduction = (hostname.indexOf('stage') < 0) && (hostname.indexOf('local') < 0)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})
